// src/constants/menus/menu-config.ts
import { MenuConfig, UserRole, UserGroup } from './types';
import { MenuIcons } from './icons';

export const ROLE_TO_GROUPS: Record<UserRole, UserGroup[]> = {
  right_owner: ['PRIMARY_USERS'],
  licensee: ['PRIMARY_USERS'],
  admin: ['ADMIN_USERS'],
  staff: ['ADMIN_USERS'],
  monitor: ['MONITORING_TEAM'],
  legal: ['SUPPORT_MONITORING'],
  support_specialist: ['SUPPORT_MONITORING'],
  business_developer: ['BUSINESS_DEVELOPMENT'],
  security_analyst: ['RISK_SECURITY'],
  guest: ['GUEST_USERS'],
};

export const MENU_CONFIGS: MenuConfig[] = [
  // PRIMARY_USERS - CONSOLIDATED (50 items)
  {
    key: 'content-creator',
    label: 'myContentCreatorStudio',
    icon: MenuIcons.Folder,
    groups: ['PRIMARY_USERS'],
    roles: ['right_owner'],
    children: [
      { key: 'register-works', label: 'registerWorks', url: '/content/create', icon: MenuIcons.Add },
      { key: 'manage-catalog', label: 'manageCatalog', url: '/catalog/manage', icon: MenuIcons.List },
      // { key: 'publishing-settings', label: 'publishContent', url: '/marketplace/publishing', icon: MenuIcons.Upload },
      { key: 'creator-dashboard', label: 'creatorDashboard', url: '/marketplace/creator', icon: MenuIcons.Chart },
      // { key: 'creator-content', label: 'contentManagement', url: '/marketplace/creator/content', icon: MenuIcons.Collection },
      // { key: 'creator-analytics', label: 'creatorAnalytics', url: '/marketplace/creator/analytics', icon: MenuIcons.Stats },
      { key: 'incoming-requests', label: 'incomingRequests', url: '/marketplace/creator/requests', icon: MenuIcons.FileContract },
      { key: 'payout-management', label: 'payoutManagement', url: '/marketplace/creator/payouts', icon: MenuIcons.Cash },
    ],
  },
  {
    key: 'certificates',
    label: 'certificatesCompliance',
    icon: MenuIcons.Certificate,
    groups: ['PRIMARY_USERS', 'SUPPORT_MONITORING'],
    children: [
      { key: 'vietrro-certificate', label: 'vietrroCertificate', url: '/certificates/vietrro', icon: MenuIcons.Stamp },
      { key: 'wipo-certificate', label: 'wipoCertificate', url: '/certificates/wipo', icon: MenuIcons.Globe },
      { key: 'noip-certificate', label: 'noipCertificate', url: '/certificates/noip', icon: MenuIcons.Flag },
      { key: 'association-licenses', label: 'associationLicenses', url: '/certificates/association', icon: MenuIcons.Handshake },
      { key: 'license-tracking', label: 'licenseTracking', url: '/certificates/tracking', icon: MenuIcons.Search },
      { key: 'certificate-verification', label: 'certificateVerification', url: '/certificates/verification', icon: MenuIcons.ShieldAlt },
      { key: 'license-history', label: 'licenseHistory', url: '/certificates/history', icon: MenuIcons.HistoryAlt },
      {
        key: 'integrations',
        label: 'certificateIntegrations',
        icon: MenuIcons.Link,
        roles: ['right_owner', 'admin'],
        children: [
          { key: 'vietrro-wipo-integration', label: 'vietrroWipoIntegration', url: '/certificates/integrations/vietrro-wipo', icon: MenuIcons.Stamp },
          // { key: 'vietrro-integration', label: 'vietrroIntegration', url: '/certificates/integrations/vietrro', icon: MenuIcons.Stamp },
          // { key: 'wipo-integration', label: 'wipoIntegration', url: '/certificates/integrations/wipo', icon: MenuIcons.Globe },
          { key: 'noip-integration', label: 'noipIntegration', url: '/certificates/integrations/noip', icon: MenuIcons.Flag },
          { key: 'association-integration', label: 'associationIntegration', url: '/certificates/integrations/association', icon: MenuIcons.Handshake },
        ],
      },
      { key: 'license-approval', label: 'licenseApproval', url: '/certificates/approval', icon: MenuIcons.ClipboardCheck, roles: ['admin', 'staff', 'legal'] },
    ],
  },
  {
    key: 'marketplace',
    label: 'marketplace',
    icon: MenuIcons.Store,
    groups: ['PRIMARY_USERS', 'GUEST_USERS'],
    children: [
      // { key: 'marketplace-home', label: 'marketplaceHome', url: '/marketplace', icon: MenuIcons.Store },
      // { key: 'browse-content', label: 'browseContent', url: '/marketplace/browse', icon: MenuIcons.SearchAlt },
      // { key: 'marketplace-dashboard', label: 'marketplaceDashboard', url: '/marketplace/dashboard', icon: MenuIcons.Chart, roles: ['right_owner', 'admin', 'staff'] },
      // {
      //   key: 'pre-license',
      //   label: 'preLicenseSystem',
      //   icon: MenuIcons.GavelAlt,
      //   children: [
      //     { key: 'external-search', label: 'searchInternationalWorks', url: '/marketplace/external-works/search', icon: MenuIcons.SearchAlt },
      //     { key: 'prelicense-form', label: 'preLicenseRequest', url: '/marketplace/pre-license/form', icon: MenuIcons.FileContract },
      //     { key: 'prelicense-tracker', label: 'trackPreLicense', url: '/marketplace/pre-license/tracker', icon: MenuIcons.Trending },
      //   ],
      // },
      // {
      //   key: 'author-finder',
      //   label: 'authorFinder',
      //   icon: MenuIcons.UserPlus,
      //   children: [
      //     { key: 'unclaimed-browse', label: 'browseUnclaimedContent', url: '/marketplace/unclaimed', icon: MenuIcons.SearchAlt },
      //     { key: 'vietrro-vault', label: 'vietrroVault', url: '/marketplace/unclaimed/vault', icon: MenuIcons.Archive, roles: ['right_owner', 'admin', 'staff'] },
      //     { key: 'orphan-content', label: 'orphanContent', url: '/marketplace/unclaimed/orphan', icon: MenuIcons.Globe, roles: ['right_owner', 'admin', 'monitor', 'legal'] },
      //     { key: 'my-claims', label: 'myClaimRequests', url: '/marketplace/unclaimed/my-claims', icon: MenuIcons.ClipboardList, roles: ['right_owner', 'licensee'] },
      //     { key: 'content-verification', label: 'contentVerification', url: '/marketplace/verify', icon: MenuIcons.ShieldAlt },
      //   ],
      // },
    ],
  },
  {
    key: 'payments-revenue',
    label: 'paymentsRevenue',
    icon: MenuIcons.Wallet,
    groups: ['PRIMARY_USERS'],
    children: [
      // { key: 'payment-dashboard', label: 'paymentDashboard', url: '/dashboard/payments', icon: MenuIcons.CreditCard },
      // { key: 'my-licenses', label: 'myLicenses', url: '/licenses', icon: MenuIcons.File },
      // { key: 'my-invoices', label: 'myInvoices', url: '/invoices', icon: MenuIcons.Receipt },
      // { key: 'installment-payments', label: 'installmentPayments', url: '/dashboard/payments/installments', icon: MenuIcons.Payment },
      // { key: 'refund-management', label: 'refundManagement', url: '/dashboard/payments/refunds', icon: MenuIcons.Undo },
      // { key: 'revenue-statistics', label: 'revenueStatistics', url: '/rights/revenue-dashboard', icon: MenuIcons.Chart, roles: ['right_owner'] },
      // { key: 'withdraw-earnings', label: 'copyrightPayout', url: '/rights/payments/withdraw', icon: MenuIcons.Money, roles: ['right_owner'] },
    ],
  },
  {
    key: 'protection-support',
    label: 'protectionSupport',
    icon: MenuIcons.Shield,
    groups: ['PRIMARY_USERS'],
    children: [
      { key: 'violation-dashboard', label: 'violationReportsManagement', url: '/rights/violation-dashboard', icon: MenuIcons.List },
      { key: 'my-reports', label: 'myReports', url: '/rights/my-reports', icon: MenuIcons.Search },
      { key: 'report-violation', label: 'reportViolation', url: '/violations/report', icon: MenuIcons.AddBox },
      { key: 'identity-protection', label: 'identityProtectionCenter', url: '/identity-protection/dashboard', icon: MenuIcons.UserShield, disabled: true },
      { key: 'ai-scan', label: 'aiAutoScan', url: '/monitoring/ai-scan', icon: MenuIcons.Search, disabled: true },
      { key: 'create-dispute', label: 'createDispute', url: '/disputes/create', icon: MenuIcons.Warning },
    ],
  },
  {
    key: 'licensing-contracts',
    label: 'licensingContracts',
    icon: MenuIcons.FileContract,
    groups: ['PRIMARY_USERS'],
    children: [
      // { key: 'discover-works', label: 'discoverWorks', url: '/public/works', icon: MenuIcons.Search },
      // { key: 'purchase-license', label: 'licensePurchase', url: '/licenses/purchase', icon: MenuIcons.CreditCard },
      // { key: 'license-payments', label: 'payments', url: '/licenses/payments', icon: MenuIcons.Money },
      // { key: 'request-license', label: 'requestMarketplaceLicense', url: '/marketplace/license/request', icon: MenuIcons.PurchaseTag },
      // { key: 'my-requests', label: 'myMarketplaceRequests', url: '/marketplace/license/my-requests', icon: MenuIcons.DocumentSearch },
      // { key: 'view-contracts', label: 'viewContracts', url: '/licenses/contracts', icon: MenuIcons.File },
      // { key: 'manage-contracts', label: 'manageContracts', url: '/licenses/contracts/manage', icon: MenuIcons.Edit },
    ],
  },

  // ADMIN_USERS
  {
    key: 'admin',
    label: 'systemAdministration',
    icon: MenuIcons.Settings,
    groups: ['ADMIN_USERS'],
    children: [
      { key: 'permissions', label: 'userManagement', url: '/admin/permissions', icon: MenuIcons.UserConfig },
      { key: 'system', label: 'systemConfiguration', url: '/admin/system', icon: MenuIcons.Settings },
      { key: 'activity-logs', label: 'activityLogs', url: '/admin/activity-logs', icon: MenuIcons.History },
      { key: 'api', label: 'apiManagement', url: '/partners/api', icon: MenuIcons.Global },
    ],
  },
  {
    key: 'staff',
    label: 'staffTasks',
    icon: MenuIcons.File,
    groups: ['ADMIN_USERS'],
    children: [
      { key: 'process-contracts', label: 'processContracts', url: '/staff/contracts', icon: MenuIcons.Contract },
      { key: 'content-moderation', label: 'contentModeration', url: '/staff/content/moderation', icon: MenuIcons.Edit },
      { key: 'customer-support', label: 'customerSupport', url: '/staff/support', icon: MenuIcons.UserShield },
    ],
  },
  {
    key: 'certificate-approval',
    label: 'certificateApproval',
    icon: MenuIcons.ClipboardCheck,
    groups: ['ADMIN_USERS'],
    children: [
      { key: 'license-approval-admin', label: 'licenseApproval', url: '/certificates/approval', icon: MenuIcons.ClipboardCheck, roles: ['admin', 'staff', 'legal'] },
      { key: 'certificate-history-admin', label: 'certificateHistoryAdmin', url: '/certificates/history?view=admin', icon: MenuIcons.HistoryAlt, roles: ['admin', 'staff'] },
      { key: 'certificate-verification-admin', label: 'certificateVerificationAdmin', url: '/certificates/verification?admin=true', icon: MenuIcons.ShieldAlt, roles: ['admin', 'staff', 'legal'] },
    ],
  },
  {
    key: 'marketplace-admin',
    label: 'marketplaceAdministration',
    icon: MenuIcons.Store,
    groups: ['ADMIN_USERS'],
    children: [
      { key: 'marketplace-dashboard-admin', label: 'marketplaceDashboardAdmin', url: '/marketplace/dashboard', icon: MenuIcons.Chart },
      { key: 'content-moderation-marketplace', label: 'marketplaceContentModeration', url: '/marketplace/admin/content-moderation', icon: MenuIcons.Edit },
      { key: 'claim-review-admin', label: 'claimReviewAdministration', url: '/marketplace/unclaimed/admin/review', icon: MenuIcons.GavelAlt },
      { key: 'marketplace-analytics', label: 'marketplaceAnalytics', url: '/marketplace/admin/analytics', icon: MenuIcons.Stats },
    ],
  },
  {
    key: 'admin-payments',
    label: 'adminPaymentManagement',
    icon: MenuIcons.Wallet,
    groups: ['ADMIN_USERS'],
    children: [
      { key: 'admin-payment-overview', label: 'paymentOverview', url: '/admin/payments', icon: MenuIcons.Wallet },
      { key: 'payment-verification', label: 'paymentVerification', url: '/admin/payments/verify', icon: MenuIcons.ShieldAlt, badge: 'unverifiedPaymentCount', roles: ['admin', 'staff'] },
      { key: 'admin-transactions', label: 'transactionManagement', url: '/admin/payments/transactions', icon: MenuIcons.Receipt, roles: ['admin'] },
      { key: 'admin-refunds', label: 'refundApproval', url: '/admin/payments/refunds', icon: MenuIcons.Undo },
    ],
  },
  {
    key: 'admin-disputes',
    label: 'adminDisputeManagement',
    icon: MenuIcons.Warning,
    groups: ['ADMIN_USERS'],
    roles: ['admin', 'staff', 'support_specialist'],
    children: [
      { key: 'dispute-queue', label: 'disputeQueue', url: '/admin/disputes', icon: MenuIcons.Warning, badge: 'disputeCount' },
    ],
  },
  {
    key: 'admin-licenses',
    label: 'adminLicenseMonitoring',
    icon: MenuIcons.Activity,
    groups: ['ADMIN_USERS'],
    roles: ['admin', 'staff', 'support_specialist'],
    children: [
      { key: 'license-monitor', label: 'licenseActivationMonitor', url: '/admin/licenses/monitor', icon: MenuIcons.Activity, badge: 'failedActivationCount' },
    ],
  },

  // MONITORING_TEAM
  {
    key: 'monitoring',
    label: 'monitoring',
    icon: MenuIcons.Warning,
    groups: ['MONITORING_TEAM'],
    children: [
      { key: 'ai-scan-monitor', label: 'aiScan', url: '/monitoring/ai-scan', icon: MenuIcons.Search },
      { key: 'warnings', label: 'warnings', url: '/monitoring/warnings', icon: MenuIcons.Warning },
      { key: 'revocation', label: 'revocation', url: '/monitoring/revocation', icon: MenuIcons.Ban },
    ],
  },
  {
    key: 'certificate-monitoring',
    label: 'certificateMonitoring',
    icon: MenuIcons.Certificate,
    groups: ['MONITORING_TEAM'],
    children: [
      { key: 'certificate-verification-monitor', label: 'certificateVerificationMonitor', url: '/certificates/verification', icon: MenuIcons.ShieldAlt },
      { key: 'license-tracking-monitor', label: 'licenseTrackingMonitor', url: '/certificates/tracking?monitor=true', icon: MenuIcons.Search },
    ],
  },
  {
    key: 'marketplace-monitoring',
    label: 'marketplaceMonitoring',
    icon: MenuIcons.Store,
    groups: ['MONITORING_TEAM'],
    children: [
      { key: 'marketplace-violations', label: 'marketplaceViolations', url: '/marketplace/monitoring/violations', icon: MenuIcons.Warning },
      { key: 'content-scanning', label: 'marketplaceContentScanning', url: '/marketplace/monitoring/scan', icon: MenuIcons.Search },
    ],
  },

  // SUPPORT_MONITORING (Legal & Support)
  {
    key: 'support',
    label: 'support',
    icon: MenuIcons.UserShield,
    groups: ['SUPPORT_MONITORING'],
    disabled: true,
    children: [
      { key: 'tech-support', label: 'techSupport', url: '/support/technical', icon: MenuIcons.Settings },
      { key: 'faq-help', label: 'faqHelp', url: '/support/faq', icon: MenuIcons.Question },
      { key: 'user-onboarding', label: 'userOnboarding', url: '/onboarding/new-users', icon: MenuIcons.UserConfig },
    ],
  },
  {
    key: 'legal',
    label: 'legal',
    icon: MenuIcons.Copyright,
    groups: ['SUPPORT_MONITORING'],
    children: [
      { key: 'disputes-legal', label: 'disputes', url: '/legal/disputes', icon: MenuIcons.Scale },
      { key: 'violations-legal', label: 'violations', url: '/legal/violations', icon: MenuIcons.Gavel },
      { key: 'enforcement', label: 'enforcement', url: '/legal/enforcement', icon: MenuIcons.Lock },
    ],
  },
  {
    key: 'marketplace-legal',
    label: 'marketplaceLegal',
    icon: MenuIcons.Store,
    groups: ['SUPPORT_MONITORING'],
    children: [
      { key: 'marketplace-disputes', label: 'marketplaceDisputes', url: '/marketplace/legal/disputes', icon: MenuIcons.Scale },
      { key: 'marketplace-compliance', label: 'marketplaceCompliance', url: '/marketplace/legal/compliance', icon: MenuIcons.ShieldAlt },
      { key: 'claim-review-legal', label: 'claimReviewLegal', url: '/marketplace/unclaimed/admin/review', icon: MenuIcons.GavelAlt },
    ],
  },
  {
    key: 'marketplace-admin-support',
    label: 'marketplaceAdministration',
    icon: MenuIcons.Store,
    groups: ['SUPPORT_MONITORING'],
    roles: ['legal', 'support_specialist'],
    children: [
      { key: 'payment-confirmation-support', label: 'paymentConfirmation', url: '/admin/payment-confirmation', icon: MenuIcons.Edit },
      { key: 'marketplace-dashboard-support', label: 'marketplaceDashboardAdmin', url: '/marketplace/dashboard', icon: MenuIcons.Chart },
      { key: 'content-moderation-support', label: 'marketplaceContentModeration', url: '/marketplace/admin/content-moderation', icon: MenuIcons.Edit },
      { key: 'claim-review-support', label: 'claimReviewAdministration', url: '/marketplace/unclaimed/admin/review', icon: MenuIcons.GavelAlt },
      { key: 'marketplace-analytics-support', label: 'marketplaceAnalytics', url: '/marketplace/admin/analytics', icon: MenuIcons.Stats },
    ],
  },

  // BUSINESS_DEVELOPMENT
  {
    key: 'business',
    label: 'business',
    icon: MenuIcons.Chart,
    groups: ['BUSINESS_DEVELOPMENT'],
    children: [
      { key: 'contract-management-biz', label: 'contractManagement2', url: '/contracts/management', icon: MenuIcons.Contract },
      { key: 'partnership-management', label: 'partnershipManagement', url: '/partnerships/management', icon: MenuIcons.UserShield },
      { key: 'growth-management', label: 'growthManagement', url: '/strategy/growth', icon: MenuIcons.Chart },
    ],
  },
  {
    key: 'marketplace-business',
    label: 'marketplaceBusiness',
    icon: MenuIcons.Store,
    groups: ['BUSINESS_DEVELOPMENT'],
    children: [
      { key: 'marketplace-partnerships', label: 'marketplacePartnerships', url: '/marketplace/business/partnerships', icon: MenuIcons.Handshake },
      { key: 'marketplace-revenue', label: 'marketplaceRevenue', url: '/marketplace/business/revenue', icon: MenuIcons.Dollar },
      { key: 'marketplace-growth', label: 'marketplaceGrowthAnalysis', url: '/marketplace/business/growth', icon: MenuIcons.Trending },
    ],
  },

  // RISK_SECURITY
  {
    key: 'security',
    label: 'security',
    icon: MenuIcons.Shield,
    groups: ['RISK_SECURITY'],
    children: [
      { key: 'monitor-security', label: 'monitorSecurity', url: '/security/monitoring', icon: MenuIcons.Warning },
      { key: 'implement-security', label: 'implementSecurity', url: '/security/implementation', icon: MenuIcons.Shield },
      { key: 'analyze-risk', label: 'analyzeRisk', url: '/risk/analysis', icon: MenuIcons.Chart },
      { key: 'prevent-risk', label: 'preventRisk', url: '/risk/prevention', icon: MenuIcons.Lock },
    ],
  },
  {
    key: 'marketplace-security',
    label: 'marketplaceSecurity',
    icon: MenuIcons.Store,
    groups: ['RISK_SECURITY'],
    children: [
      { key: 'marketplace-fraud-detection', label: 'marketplaceFraudDetection', url: '/marketplace/security/fraud', icon: MenuIcons.ShieldAlt },
      { key: 'marketplace-risk-assessment', label: 'marketplaceRiskAssessment', url: '/marketplace/security/risk', icon: MenuIcons.Warning },
      { key: 'marketplace-security-monitoring', label: 'marketplaceSecurityMonitoring', url: '/marketplace/security/monitoring', icon: MenuIcons.Search },
    ],
  },

  // GUEST_USERS
  {
    key: 'public',
    label: 'explore',
    icon: MenuIcons.Explore,
    groups: ['GUEST_USERS'],
    children: [
      { key: 'works-guest', label: 'exploreDiscoverWorks', url: '/public/works', icon: MenuIcons.Search },
      { key: 'license-info', label: 'licenseInfo', url: '/public/license-info', icon: MenuIcons.File },
    ],
  },
  {
    key: 'marketplace-public',
    label: 'marketplacePublic',
    icon: MenuIcons.Store,
    groups: ['GUEST_USERS'],
    children: [
      { key: 'marketplace-browse-public', label: 'browseMarketplace', url: '/marketplace', icon: MenuIcons.Store },
      { key: 'marketplace-search-public', label: 'searchContent', url: '/marketplace/browse', icon: MenuIcons.SearchAlt },
      { key: 'unclaimed-browse-public', label: 'authorFinderPublic', url: '/marketplace/unclaimed', icon: MenuIcons.UserPlus },
      { key: 'content-verification-public', label: 'verifyContent', url: '/marketplace/verify', icon: MenuIcons.ShieldAlt },
    ],
  },
  {
    key: 'documents-guest',
    label: 'documents2',
    icon: MenuIcons.Book,
    groups: ['GUEST_USERS'],
    children: [
      { key: 'all-documents', label: 'allDocuments2', url: '/documents', icon: MenuIcons.Book },
      { key: 'search-documents', label: 'searchDocuments', url: '/documents/search', icon: MenuIcons.SearchAlt },
    ],
  },
  {
    key: 'certificate-public',
    label: 'certificatePublic',
    icon: MenuIcons.Certificate,
    groups: ['GUEST_USERS'],
    children: [
      { key: 'certificate-verification-public', label: 'certificateVerificationPublic', url: '/certificates/verification', icon: MenuIcons.ShieldAlt },
    ],
  },
];